import { DateTime } from 'luxon';
import { RetentionPolicy, RetentionRunResult } from '../RetentionPolicy';

interface LoggingRetentionProps {
  setSuccessMessage: (message: string) => void;
  setErrorMessage: (message: string) => void;
  active?: boolean;
}

export function LoggingRetention(props: LoggingRetentionProps) {
  return (
    <RetentionPolicy
      {...props}
      endpoint="/api/logging_retention/1"
      subject="Audit log"
      minimumMonths={1}
      runButtonLabel="Run audit log purge"
      warning={(months, cutoff) =>
        `Audit logs older than ${months} months (before ${cutoff}) will be permanently deleted.`
      }
      confirmation={(cutoff) => (
        <p>You are about to permanently delete all audit log records created before {cutoff}.</p>
      )}
      formatRunSuccess={(result: RetentionRunResult) =>
        `Deleted ${result.purgedCount} audit log records before ${DateTime.fromISO(result.cutoffDate).toLocaleString(DateTime.DATE_FULL)}.`
      }
    />
  );
}
